import type { RolePlayInterviewSectionSettings } from "@repo/app-types/entities/interviewSection/settings";
import type { FC } from "react";
import { RolePlayInstructionsField } from "./instructionsField.js";

export interface RolePlayInterviewSectionDefinitionSettingsProps {
  interviewSectionDefinitionId: string;
  settings: RolePlayInterviewSectionSettings;
  onChange: (
    interviewSectionDefinitionId: string,
    newSettings: RolePlayInterviewSectionSettings,
  ) => void;
}

export const RolePlayInterviewSectionDefinitionSettings: FC<
  RolePlayInterviewSectionDefinitionSettingsProps
> = (props) => {
  return (
    <div className="space-y-4 px-4 pt-0 pb-4">
      <RolePlayInstructionsField
        label="Trainee instructions"
        description="These instructions will be shown to the trainee for the entire role play exercise."
        content={props.settings.participant_instructions}
        height="24rem"
        onChange={(newContent) =>
          props.onChange(props.interviewSectionDefinitionId, {
            ...props.settings,
            participant_instructions: newContent,
          })
        }
      />

      <RolePlayInstructionsField
        label="AI agent instructions"
        description="These instructions define the behavior of the AI agent in the role play exercise."
        content={props.settings.agent_instructions}
        height="36rem"
        onChange={(newContent) =>
          props.onChange(props.interviewSectionDefinitionId, {
            ...props.settings,
            agent_instructions: newContent,
          })
        }
      />
    </div>
  );
};
